export enum EnumEstadoCivil {
    SOLTEIRO = 'Solteiro(a)',
    CASADO = 'Casado(a)',
    VIUVO = 'Viuvo(a)',
    SEPARADO_JUDICIALMENTE = 'Separado(a) Judicialmente',
    DIVORCIADO = 'Divorciado(a)',
    UNIAO_ESTAVEL = 'União estável',
    OUTROS = 'Outro'
}
